/*eslint-disable */
import appFooter from '../../components/footer/index';
import welcome from '../../components/welcome-popup/index';
var $ = window.jQuery = require('jquery');
import Vue from 'vue'
import VueCookieAcceptDecline from 'vue-cookie-accept-decline'
import "vue-cookie-accept-decline/dist/vue-cookie-accept-decline.css";
Vue.component('vue-cookie-accept-decline', VueCookieAcceptDecline)
export default {
  name: 'public-course-description',
  components: {
    'app-footer': appFooter,
    'welcome-popup': welcome
  },
  props: [],
  data() {
    return {
      preloader: true,
      courseName: '',
      courseId: '',
      courseBackgroundImage: '',
      courseDescirption: '',
      courseCatgoryName: '',
      courseCategorySlug: '',
      courseDescriptionTabs: {},
      activeTab: 0,
      author_details:'',
      expertlevel:'',
      coursesubtitle:'',
      coursecode:'',
      courseSlug:'',
      course_producer:'',
      author_details_length:'',
      status: null,
      courseType:'',
      year_published:''
    }
  },
  computed: {
    getCourseDetail() {
      this.$store.dispatch('getCourseDetail', {
          id: this.$route.params.slug
        }).then((res) => {
          if (res.code == '2000') {
            this.courseSlug = res.data.slug
            this.courseName = res.data.name;
            this.coursesubtitle = res.data.subtitle;
            this.coursecode = res.data.code;
            this.expertlevel = res.data.expertise_level
            this.author_details =  res.data.authors;
            let authors_details = res.data.authors
            this.author_details_length = authors_details.filter(authors => authors.is_producer == false);
            let producer_details = res.data.authors
            this.course_producer = producer_details.filter(producer => producer.is_producer == true);
            this.courseId = res.data.id;
            this.courseDescirption = res.data.description;
            this.courseCatgoryName = res.data.category[0].name;
            this.courseCategorySlug = res.data.category[0].slug;
            this.courseBackgroundImage = res.data.category[0].bg_image;
            this.courseDescriptionTabs = res.data.tabs;
            this.courseproducer = res.data.producer;
            this.courseType = res.data.course_type;
            this.year_published = res.data.created_at;
            document.title = ' Oddvega - ' + this.courseName;
            this.preloader = false;
            $('.app-loader').hide()
          }
        })
        .catch((err) => {})
    }
  },
  // Override the meta.
  metaInfo() {
    return {
      meta: [{
        name: 'description',
        content: this.courseDescirption.slice(0, 160) + '.'
      }]
    }
  },
  mounted() {
    if(this.$route.params.slug ==  'login'){
      this.$router.push('/login/');
    }
    this.getCourseDetail;
    this.renderMathJax()
    if (process.env.NODE_ENV == 'production') {
      this.$scriptLoader.load("https://www.googletagmanager.com/gtag/js?id=UA-152519411-1")
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'UA-152519411-1');
    }
  },
  methods: {
    renderMathJax(){
      setTimeout(()=>{
        if(window.MathJax){
          window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub], () => console.log('done'));
        }
      },100)
    },
    pdfDownloadFun(){
      var course_str = this.courseName.toLowerCase();
      var str_replace = course_str.split(' ').join('_');
      console.log(str_replace)
      this.$store.dispatch('getPubCourseDetailPdf', {
          slug: this.courseSlug
        }).then((res) => {
          var blob=new Blob([res]);
          var link=document.createElement('a');
          link.href=window.URL.createObjectURL(blob);
          link.download= str_replace + ".pdf";
          link.click();
        })
        .catch((err) => {})
    },
    showActive(value) {
      this.activeTab = value
    },
  },
  beforeCreate: function() {
    $('body').addClass('course-descirption public-routes');
  },
  beforeRouteLeave: function(to, from, next) {
    $('body').removeClass('course-descirption public-routes');
    next();
  },
  watch:{
    getCourseDetail() {
      this.renderMathJax()
    }
  }
}